<template>
    <div class="flex border-t border-b -mb-px border-gray-200 bg-white">
        <div class="flex-1 border-r border-l border-gray-200 px-2 py-1 -ml-px" v-text="item.name"></div>
        <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px truncate" v-text="item.unitOfMeasure"></div>
        <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right" v-text="item.required"></div>
        <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right" v-text="item.requested"></div>
        <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right" v-text="item.ordered"></div>
        <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right" v-text="item.received"></div>
        <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right" v-text="item.required-item.received"></div>
    </div>
</template>

<script>

import {toCurrency, resolveNumericText} from "../../utils";
import UiDropdown from "../ui/UiDropdown.vue";
import PageCell from "../ui/PageCell.vue";
import * as math from "mathjs";

export default {
    components: {PageCell, UiDropdown},
    props: {
        item: Object,
    },
    data() {
        return {
        }
    },
    computed: {},
    methods: {
    },
    mounted() {
    }
}
</script>
